import { render } from "./HintBlock.vue?vue&type=template&id=5376e6ba&scoped=true"
const script = {}

import "./HintBlock.vue?vue&type=style&index=0&id=5376e6ba&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5376e6ba"]])

export default __exports__